<template>
    <div>
        <div class="row">
            <div class="col">
                <app-multi-lang-input id="name"
                                      v-model="form.name"
                                      name="name"
                                      rules="required"
                                      :langs="locales && Object.keys(locales)">
                    <template #label>
                        {{ $t('Name') }}*
                    </template>
                </app-multi-lang-input>
            </div>
            <div class="col">
                <app-datepicker id="start_date"
                                v-model="form.start_date"
                                name="start_date">
                    <template #label>
                        {{ $t('Start') }}
                    </template>
                </app-datepicker>
            </div>
            <div class="col">
                <app-datepicker id="end_date"
                                v-model="form.end_date"
                                name="end_date">
                    <template #label>
                        {{ $t('End') }}
                    </template>
                </app-datepicker>
            </div>
            <div class="col">
                <app-input id="discount_percent" v-model="form.discount_percent" type="number" name="discount_percent">
                    <template #label>
                        {{ $t('Discount') }} %
                    </template>
                </app-input>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <app-select id="vehicles"
                            v-model="form.vehicles"
                            :options="vehicles.map(c => c.id)"
                            name="vehicles"
                            searchable
                            multiple
                            not-empty
                            closeOnSelect
                            :custom-label="id => vehicles.some(c => c.id === id) ? (
                                `${vehicles.find(c => c.id === id).make.name}
                                ${vehicles.find(c => c.id === id).model.name} -
                                ${vehicles.find(c => c.id === id).reg_no}`) : null">
                    <template #label>
                        {{ $t('Vehicles') }}
                    </template>
                </app-select>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col">
                <app-multi-lang-quill
                    :title="$t('Comments')"
                    id="comments"
                    v-model="form.comments"
                    :langs="locales && Object.keys(locales)" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <app-upload input-class="form-control custom-green-input-bg"
                            :max-size="maxMbSize"
                            :placeholder="$t('Click here to choose file')"
                            @size-exceeded="onSizeExceeded"
                            @remove="removeFile"
                            @file="onFile"/>
                <p>{{ $t('Recommended image size') }}: 1235px x 146px</p>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import VehicleService from '@services/vehicle.service';

export default {
    name: 'OfferForm',
    props: {
        form: Object
    },
    data() {
        return {
            maxMbSize: 10,
            vehicles: []
        };
    },
    computed: {
        ...mapGetters(['locales']),
    },
    methods: {
        onFile(file) {
            this.form.img = file;
        },
        onSizeExceeded(size) {
            alert(`${this.$t('File size')} ${Math.round((size + Number.EPSILON) * 100) / 100}Mb ${this.$t('exceeds the limit of')} ${this.maxMbSize}Mb!`);
        },
        removeFile() {
            this.form.img = {};
        },
        getVehicles(){
            VehicleService.noEmpties().then(res => this.vehicles = res);
        }
    },
    created() {
        this.getVehicles();
    }
};
</script>
